import { Pipe, PipeTransform } from '@angular/core';
import { ControlType, ControlTypeTranslations } from 'src/app/core/interfaces/control-type.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({ name: 'controlType', pure: false })
export class ControlTypePipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) { }

    transform(value: ControlType | number): string {
        if (value === null || value === undefined) return '';
        return this.localizationService.getCachedLanguage() === 'ar'
            ? ControlTypeTranslations[value as ControlType] || value.toString()
            : value.toString();
    }
}